import { FormControl, FormGroup, FormArray, FormBuilder, AbstractControl } from '@angular/forms'

import { BasePrompt, ControlTypes, MultiRelationshipPrompt, SingleRelationshipPrompt, CheckboxPrompt } from '../../models'
import { BaseModel } from '../../../data/models'

export class PromptControlService {
  private _controlTypeStrategies = new Map<ControlTypes, (prompt) => AbstractControl>()

  constructor(
    private _formBuilder: FormBuilder
  ) {
    this._controlTypeStrategies.set(ControlTypes.MultiRelationship, this._multiRelationshipStrategy)
    this._controlTypeStrategies.set(ControlTypes.SingleRelationship, this._singleRelationshipStrategy)
    this._controlTypeStrategies.set(ControlTypes.Checkbox, this._checkboxStategy)
  }

  public toFormGroup(prompts: Array<BasePrompt<any>> ) {
    const formGroup: FormGroup = this._formBuilder.group({})

    prompts.forEach((prompt) => {
      formGroup.setControl(prompt.key, this._getControl(prompt))
    })
    return formGroup
  }

  private _getControl(prompt): AbstractControl {
    const strategy = this._controlTypeStrategies.get(prompt.controlType) || this._defaultControlTypeStrategy
    return strategy.call(this, prompt)
  }

  private _multiRelationshipStrategy(prompt: MultiRelationshipPrompt<BaseModel>): FormArray {
    const formArray = this._formBuilder.array([])
    prompt.forms.forEach((promptGroup) => {
        formArray.push(this.toFormGroup(promptGroup.prompts))
    })
    return formArray
  }

  private _singleRelationshipStrategy(prompt: SingleRelationshipPrompt<BaseModel>): FormGroup {
    return this.toFormGroup(prompt.form.prompts)
  }

  private _checkboxStategy(prompt: CheckboxPrompt): FormArray {
    const formArray = this._formBuilder.array([])
    let formGroup
    let checked = false
    prompt.options.subscribe((options) => {
      options.forEach((option) => {
        formGroup = {}
        checked = prompt.value.includes(option.value)
        formGroup[option.value] = [checked, prompt.validators]
        formArray.push(this._formBuilder.group(formGroup))
      })
    })
    return formArray
  }

  private _createFormGroup(prompts: Array<BasePrompt<any>>) {
    const formGroup = {}
    prompts.forEach((subPrompt) => {
      formGroup[subPrompt.key] = [subPrompt.value, subPrompt.validators]
    })
    return this._formBuilder.group(formGroup)
  }

  private _defaultControlTypeStrategy(prompt: BasePrompt<any>) {
    return this._formBuilder.control(prompt.value, prompt.validators)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/forms/services/prompt-control/prompt-control.service.ts